import React from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';

const AdvancedSearchControls = ({onReset, onSave, onSearch}) => {
    return(
      <ButtonContainer>
        <ActionButton onClick={onReset}>
          <StyledIcon type="undo" />
          Reset
        </ActionButton>
        <ActionButton onClick={onSave}>
          <StyledIcon type="save" />
          Save
        </ActionButton>
        <ActionButton onClick={onSearch}>
          <StyledIcon type="search" />
          Search
        </ActionButton>
      </ButtonContainer>
    )
}

const ButtonContainer = styled.div`
  display: flex;
  background-color: #384047;
  user-select: none;
`

const StyledIcon = styled(Icon)`
  margin-right: 10px;
  font-size: 12px;
`

const ActionButton = styled.div`
  flex: 1;
  display: flex;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  height: 30px;
  color: #eee;
  border: 1px solid #d9d9d9;
  border-left: none;
  cursor: pointer;
  :not(:last-child) {
    border-right: 1px solid #d9d9d9;
  }
  :hover {
    color: #fff;
    background-color: #4d5a63;
  }
`

export default AdvancedSearchControls;